/**
 * Node Modules
 */
import React from 'react'

/**
 * Application Modules
 */
import './style.css'
import Section from '../../../components/section'
import SectionHeading from '../../../components/section-heading'
import BigLinks from '../../../components/big-links'
import Grid from '../../../components/grid'

/**
 * Component
 */
export default function OpenRoles({ hed, dek, openRolesData }) {
  return (
    <Section className="open-roles" id="open-roles">
      <Grid>
        <SectionHeading hed={hed} dek={dek} />
        <BigLinks
          className="column-start-1 column-end-6 column-start-3--t column-end-10--t"
          links={openRolesData}
        />
      </Grid>
    </Section>
  )
}
